import event from '../../event/event';

export default event('/collections/edit/show');
